import React from 'react';

export const Minus = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M17.0711 10H2.92893'
                stroke='currentColor'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    );
};

export default Minus;
